module.exports = __webpack_public_path__ + "img/secalot.315d8f14.jpg";